import { render, staticRenderFns } from "./HelpingFamilyFriends.vue?vue&type=template&id=f5bb907c&"
import script from "./HelpingFamilyFriends.vue?vue&type=script&lang=js&"
export * from "./HelpingFamilyFriends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports